export default __webpack_public_path__ + "static/img1-8798579710b317a6e802e56cfc89e564.png";